import React, { forwardRef } from "react";
import { Helmet } from "react-helmet";
import Recaptcha from "react-recaptcha";
import { isNullOrWhiteSpace } from "../shared/string";
import { isBrowser } from "../utilities/isBrowser";

export const ReCaptcha = forwardRef<Recaptcha, Recaptcha.RecaptchaProps>((props, ref) => {
    if (isNullOrWhiteSpace(props.sitekey)) {
        return null;
    }

    return (
        <>
            <Helmet>
                <script
                    id="recaptcha-script"
                    key="recaptcha-script"
                    data-react-helmet="true"
                    src="https://www.google.com/recaptcha/api.js?render=explicit"
                    type="text/javascript"
                    async
                    defer
                />
            </Helmet>
            {isBrowser() &&
              <Recaptcha ref={ref} {...props} />
            }
        </>
    );
});
